import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.object.assign.js";
var _excluded = ["id", "text", "expanded", "children"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2017,2020. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import React from 'react';
import PropTypes from 'prop-types';
import Alert from './Alert';
import Collapsible from './Collapsible';
var HelpMessage = function HelpMessage(_ref) {
  var id = _ref.id,
    text = _ref.text,
    expanded = _ref.expanded,
    children = _ref.children,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Collapsible, {
    className: "wds-c-help-message",
    height: expanded ? 'auto' : 0
  }, /*#__PURE__*/React.createElement(Alert, _extends({
    id: id,
    dismissable: false,
    icon: "help",
    iconSize: "medium",
    type: "info",
    text: text
  }, otherProps), children));
};

/*
 * Use the HelpMessage with the HelpButton
 * to create help patter for form inputs.
 * Always set an `id` on the Help message and
 * use that `id` as the `toggleId` of the HelpButton.
 * This way, the HelpButton knows to which element it's associated
 * and it will show/hide it when clicked.
 */
HelpMessage.propTypes = {
  /** use this id as the `toggleId` of the HelpButton  */
  id: PropTypes.string.isRequired,
  /** help text  */
  text: PropTypes.node,
  /** used by screen readers to determine expanded state */
  expanded: PropTypes.bool,
  /** alert child elements */
  children: PropTypes.node
};
HelpMessage.defaultProps = {
  text: undefined,
  expanded: false,
  children: undefined
};
export default HelpMessage;